export default __webpack_public_path__ + "static/media/marcella.d16b1852.jpg";